/*
 * © 2023 Vertafore, Inc. All rights reserved.
 * Reproduction and distribution without the written permission of Vertafore is prohibited.
 */
import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./rootReducer";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { InitialStateType } from "./rootType";

export const history = createBrowserHistory();

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function configureStore(initialState: InitialStateType) {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    initialState as any,
    composeWithDevTools(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        thunk
      )
    )
  );

  return { store };
}
